import type { PropsWithChildren } from 'react';
import type React from 'react';
import styled from 'styled-components';

export const Page: React.FC<PropsWithChildren> = ({ children }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100dvh;
  width: 100vw;
  overflow: hidden;
  background-color: #f1f1f1;
`;
